
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import Scroll from '@/components/scroller'
import Storage from '@/storage'
import { getOrderlist,confirmGoods } from '@/api/youzheng.js'
import config from '@/config/index'
export default {
name: 'orderlist',
components: {
Search,
Flexbox,
FlexboxItem,
Scroll,
LoadMore,
XButton,
Cell
},
data () {
return {
searchVal: '',
baseUrl: config.baseUrl,
selected: 0,
orderList: [],
rows: 10,
page: 1,
notFirstLoad: false,
loadMoreDom: null
}
},
created () {
this.getlist()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
activated () {
this.listDom.scrollTop = config.scrollPosition.y
},
beforeRouteLeave (to, from, next) {
config.scrollPosition.y = this.listDom.scrollTop
next()
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
},
methods:{

godetail(id){
this.$router.push({ name: 'mallOrderDetail', params: { id: id } })
},

getlist(type,done){
getOrderlist({
accountid: this.accountid,
insertsource: 1,
grouptype: '',
statusid: '',
startdate: '',
startdate: '',
enddate: '',
searchword: this.searchVal,
userid: this.userid,
page: this.page,
rows: this.rows
}).then( res => {
this.notFirstLoad = true
if (type === 'refresh' || type === 'search') {
this.orderList = []
this.listDom.scrollTop = 0
}
if(res.returnValue.list !=="" && res.returnValue.list.length>0){
res.returnValue.list.forEach((item,index) => {
this.$set(this.orderList,this.orderList.length,item)
})
}
if (res.returnValue.list.length === 0 || res.returnValue.count < this.rows) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
}).catch(() => {
this.notFirstLoad = true
done && done()
})
},

refresh (done) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getlist('refresh', done)
},

loadMore (done) {
this.page++
this.getlist('more', done)
},

exchange(id){
this.$router.push({name:'mallSubmitOrders', params:{id:id}})
},

onSearch(){
this.getlist('search')
},

onCancel(){
this.searchVal = ''
this.getlist('search')
},

confirm(id){
var that = this
this.$vux.confirm.show({
title: '确认收货',
content: '请确认您已经收到商品！',
onCancel : () => {
},
onConfirm : () => {
confirmGoods({
userid: that.userid,
accountid: that.accountid,
orderid: id
}).then(res=>{
that.$router.push({name:'mallIndex'})
})
}
})
}
}
}
